import { schema } from 'normalizr';
import has from 'lodash/has';
import isNil from 'lodash/isNil';

import userSchema from './user';
import orgSchema from './org';
import { apiKeySchema } from './apiKey';
import credentialSchema from './credential';
import sinkSchema from './sink';
import vendorEndpointSchema from './vendorEndpoint';
import vendorSchema from './vendor';

import { SCHEMA_TYPE_SOURCES, SCHEMA_TYPE_DATA_SETS } from '../constants/schemaTypes';

const dataSetSchema = new schema.Entity(SCHEMA_TYPE_DATA_SETS, {
  owner: userSchema,
  org: orgSchema,
});

const sourceSchema = new schema.Entity(
  SCHEMA_TYPE_SOURCES,
  {
    owner: userSchema,
    org: orgSchema,
    data_credentials: credentialSchema,
    data_sets: [dataSetSchema],
    data_sink: sinkSchema,
    vendor_endpoint: vendorEndpointSchema,
    vendor: vendorSchema,
    api_keys: [apiKeySchema],
  },
  {
    processStrategy: (value) => {
      if (has(value, 'vendor') && !isNil(value.vendor)) {
        return { ...value, vendor_id: value.vendor.id };
      }

      if (has(value, 'source_config.vendor_id') && !isNil(value.source_config.vendor_id)) {
        return { ...value, vendor_id: value.source_config.vendor_id };
      }

      return value;
    },
  },
);

export default sourceSchema;
